/* ==========================================================================
   FEATURED PRODUCT (Premium)  —  featured-product-premium.js
   ========================================================================== */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function safeJSON(s) { try { return JSON.parse(s); } catch (e) { return null; } }

  function initSection(section) {
    if (section.dataset.fppInit === '1') return;
    section.dataset.fppInit = '1';
    var $ = function (sel) { return section.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(section.querySelectorAll(sel)); };

    var showSave = section.dataset.saveBadge === '1';

    /* ---- gallery ---- */
    var slides = $$('.fpp__slide');
    var thumbs = $$('.fpp__thumb');
    function showMedia(id) {
      slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.dataset.mediaId === String(id)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });

    /* ---- wishlist ---- */
    var wish = $('[data-fpp-wish]');
    if (wish) wish.addEventListener('click', function () {
      wish.classList.toggle('is-active');
      wish.textContent = wish.classList.contains('is-active') ? '♥' : '♡';
    });

    /* ---- variants ---- */
    var variantsEl = $('[data-fpp-variants]');
    var pricesEl = $('[data-fpp-prices]');
    var variants = variantsEl ? safeJSON(variantsEl.textContent) : null;
    var prices = pricesEl ? safeJSON(pricesEl.textContent) : {};
    var idInput = $('[data-fpp-variant-id]');
    var priceWrap = $('[data-fpp-price]');
    var stockWrap = $('[data-fpp-stock]');
    var stockText = $('[data-fpp-stock-text]');
    var addBtn = $('[data-fpp-add]');
    var addText = $('[data-fpp-add-text]');
    var buyBtn = $('[data-fpp-buy]');

    function selectedOptions() {
      var o = [];
      $$('[data-fpp-option]:checked').forEach(function (i) { o[parseInt(i.dataset.optionPosition, 10) - 1] = i.value; });
      return o;
    }
    function matchVariant(o) {
      if (!variants) return null;
      return variants.find(function (v) { return o.every(function (val, i) { return v.options[i] === val; }); });
    }
    function updateForVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      $$('[data-selected-option]').forEach(function (sp) {
        var pos = parseInt(sp.dataset.selectedOption, 10);
        sp.textContent = v.options[pos - 1] || '';
      });
      var pinfo = prices[v.id];
      if (priceWrap && pinfo) {
        var html = pinfo.price;
        if (pinfo.compare_raw && pinfo.compare_raw > pinfo.price_raw) {
          html += ' <s>' + pinfo.compare + '</s>';
          if (showSave) {
            var pct = Math.round((pinfo.compare_raw - pinfo.price_raw) * 100 / pinfo.compare_raw);
            html += ' <span class="fpp__save">-' + pct + '%</span>';
          }
        }
        priceWrap.innerHTML = html;
      }
      var available = v.available;
      if (addBtn) addBtn.disabled = !available;
      if (buyBtn) buyBtn.disabled = !available;
      if (addText) addText.textContent = available ? (addText.dataset.in || addText.textContent) : (addText.dataset.out || 'Sold out');
      if (stockWrap) {
        stockWrap.classList.toggle('is-out', !available);
        if (stockText) stockText.textContent = available ? (stockText.dataset.in || stockText.textContent) : (stockText.dataset.out || 'Sold out');
      }
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
    }
    $$('[data-fpp-option]').forEach(function (i) {
      i.addEventListener('change', function () { updateForVariant(matchVariant(selectedOptions())); });
    });

    /* ---- quantity ---- */
    var qtyInput = $('.fpp__qty input');
    var minus = $('[data-qty-minus]');
    var plus = $('[data-qty-plus]');
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    if (minus) minus.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, qty() - 1); });
    if (plus) plus.addEventListener('click', function () { if (qtyInput) qtyInput.value = qty() + 1; });

    /* ---- cart ---- */
    var form = $('[data-fpp-form]');
    var buyBehavior = section.dataset.buyBehavior || 'checkout';
    function currentId() { return idInput ? idInput.value : (variants && variants[0] && variants[0].id); }

    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'fpp__toast'; t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-visible'); });
      setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 250); }, 2200);
    }
    function refreshCartCount() {
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-count')
            .forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: c } }));
        }).catch(function () {});
    }
    function addToCart(redirect) {
      var id = currentId();
      if (!id) return;
      var btn = redirect ? buyBtn : addBtn;
      if (btn) btn.classList.add('is-loading');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty() })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (!res.ok) { toast(res.d && res.d.description ? res.d.description : 'Could not add to cart'); return; }
          if (redirect) {
            window.location.href = buyBehavior === 'cart' ? (ROOT + 'cart') : (ROOT + 'checkout');
          } else {
            refreshCartCount();
            toast('✓ Added to cart');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          }
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Network error'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    if (buyBtn) buyBtn.addEventListener('click', function () { addToCart(true); });

    /* ---- init ---- */
    if (variants) updateForVariant(matchVariant(selectedOptions()));
  }

  function boot() { document.querySelectorAll('.fpp[data-section-id]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.fpp[data-section-id]');
    if (el) { el.dataset.fppInit = ''; initSection(el); }
  });
})();
